import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../firebase"; // Import your firebase config
import "./UpcomingEvents.css";
import { PhotoProvider, PhotoView } from "react-photo-view";
import "react-photo-view/dist/react-photo-view.css";

const UpcomingEvents = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "upcomingEvents"));
        const eventList = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setEvents(eventList);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching events: ", error);
        setLoading(false);
      }
    };

    fetchEvents();
  }, []);

  const handleRegisterButton = (googleFormLink) => {
    // Open the Google Form link in a new tab
    window.open(googleFormLink, "_blank");
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <div className="event-upcoming-container">
        <div className="donation-title">
          <h4>UPCOMING EVENTS</h4>
          <div className="title-underline-donation"></div>
        </div>
        <div
          className="events-container"
          style={{
            display: "flex",
            justifyContent: "space-around",
            padding: "20px",
          }}
        >
          {events.map((event) => (
            <div key={event.id} className="event-card">
              <div className="upcoming-events-img">
                <PhotoProvider>
                  <PhotoView src={event.posterUrl}>
                    <img
                      src={event.posterUrl}
                      alt={event.title}
                      style={{
                        width: "100%",
                        height: "200px",
                        objectFit: "cover",
                        cursor: "pointer",
                      }}
                    />
                  </PhotoView>
                </PhotoProvider>
              </div>
              <div className="event-date">{event.date}</div>
              <h3 className="event-title">{event.eventName}</h3>
              <p
                style={{ color: "black", marginBottom: "10px" }}
                className="event-time-description"
              >
                <strong style={{ marginRight: "10px" }}>{event.time}</strong>
                <br />
                {event.location}
              </p>

              <p style={{ color: "grey" }} className="event-time-description">
                {event.description}
              </p>

              <button
                className="register-btn-upcoming"
                onClick={() => handleRegisterButton(event.googleFormLink)}
              >
                Register
              </button>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default UpcomingEvents;
